import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import TableRow from '@material-ui/core/TableRow'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import EditIcon from '@material-ui/icons/Edit'
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import { remove } from 'local-storage'
import { useUserDispatcher } from '@hooks'
import moment from 'moment'
import Icon from '@material-ui/core/Icon'
import config from '@config'
import { get } from 'local-storage'
import { getUsers } from '../../services/restAPI/user/userService'

interface Column {
  id: string
  subId?: string
  label: string
  minWidth?: number
  align?: 'right'
  format?: (value: number) => string
}

const columns: Column[] = [
  // { id: 'actions', label: 'Actions', minWidth: 100 },
  { id: 'no', label: 'No', minWidth: 100 },
  { id: 'firstName', label: 'First Name', minWidth: 100 },
  { id: 'lastName', label: 'Last Name', minWidth: 100 },
  { id: 'level', label: 'User Level', minWidth: 100 },
  { id: 'email', label: 'Email', minWidth: 100 },
  // { id: 'userName', label: 'User Name', minWidth: 100 },
  { id: 'isActive', label: 'Is Active?', minWidth: 100 },
  { id: 'activatedDate', label: 'Activation Date', minWidth: 100 },
  { id: 'createdOn', label: 'Created Date', minWidth: 100 },
  { id: 'numberOfLearners', label: 'Number of Active Learners', minWidth: 100 },
]

// const skipSortField: string[] = ['actions']

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
})

// const takeData = 50

const Users: React.FC = () => {
  const { clearUserAuthData } = useUserDispatcher()
  const classes = useStyles()
  // const [page, setPage] = useState(0)
  // const [skip, setSkip] = useState(0)
  // const [filter, setFilter] = useState(null)
  // const [order, setOrder] = useState('asc');
  // const [orderBy, setOrderBy] = useState('calories')
  // const [sortBy, setSortBy] = useState(null)
  // const [isLoading, setIsLoading] = useState(false)

  // const [errorField, setErrorField] = useState(false)
  // const [errorValue, setErrorValue] = useState(false)

  // const [operator, setOperator] = useState("*")
  // const [field, setField] = useState("-SELECT-")
  // const [value, setValue] = useState("")

  const [users, setUsers] = useState<any[]>([])

  const goToLogin = () => {
    remove('token')
    clearUserAuthData()
  }

  const populateUsers = async () => {
    getUsers()
      .then(users => {
        console.log(users)
        setUsers(users)
      })
      .catch(err => {
        if (err.message == "authorization") {
          goToLogin()
        }
      })
  }

  useEffect(() => {
    populateUsers()
  }, [])

  const formatField = (column: Column, value: any, row: any, idx: number) => {
    let result = value
    switch (column.id) {
      case 'no':
        result = idx + 1
        break
      case 'numberOfLearners':
        result = row.activeLearnerIds.length
        break
      case 'isActive':
        result = row.activatedDate ? 'Yes' : 'No'
        break
      case 'activatedDate':
      case 'createdOn':
        if (value) result = moment(value).format('DD/MM/yyyy HH:mm:ss UTC')
        else result = value
        break
      case 'actions':
        result = (
          <>
            <Button startIcon={<LocalLibraryIcon />} variant="contained" size="small" color="primary" onClick={() => { }}>
              View
            </Button>
          </>
        )
        break
    }

    return result
  }

  return (
    <>
      {/* <form style={{
        border: '1px solid #dedede',
        padding: '20px',
        borderRadius: '5px',
        background: '#fff',
        width: '400px'
      }} noValidate autoComplete="off">
        <FormControl fullWidth>
          <InputLabel htmlFor="Operator">Field</InputLabel>
          <Select
            native
            value={field}
            disabled={isLoading}
            onChange={e => {
              const val = e.currentTarget.value
              setField(val)
              setErrorField(val === '')
              setValue("")
              setErrorValue(false)
            }}
            inputProps={{
              name: 'field',
              id: 'field',
            }}
            fullWidth
          >
            <option value="-SELECT-">-Select Field-</option>
            <option value="FirstName">First Name</option>
            <option value="Email">Email</option>
            <option value="LastName">Last Name</option>
            <option value="level">User Level</option>
          </Select>
          {errorField && <span style={{ color: 'red', fontSize: 12 }}>Field is required</span>}
        </FormControl>
        <div style={{ marginBottom: 20 }} />
        {field === 'level' && (<FormControl fullWidth>
          <InputLabel htmlFor="Value">Value</InputLabel>
          <Select
            native
            value={value}
            disabled={isLoading}
            onChange={e => {
              const val = e.currentTarget.value ?? ''
              setValue(val)
              setErrorValue(val === '' || val === '-SELECT-')
            }}
            inputProps={{
              name: 'value',
              id: 'value',
            }}
            fullWidth
          >
            <option value="-SELECT-">-Select Value-</option>
            <option value="NEW_COACH">New Coach</option>
            <option value="EMERGING_COACH">Emerging Coach</option>
            <option value="GREAT_COACH">Great Coach</option>
            <option value="EXPERT_COACH">Expert Coach</option>
            <option value="MASTER_COACH">Master Coach</option>
          </Select>
          {errorValue && <span style={{ color: 'red', fontSize: 12 }}>Value is required</span>}
        </FormControl>)}
        {(field !== 'UserType' && field !== 'level') && (<FormControl fullWidth>
          <TextField
            autoFocus
            id="Value"
            label="Value"
            value={value}
            fullWidth
            inputProps={{ maxLength: 50, shrink: true, }}
            disabled={isLoading}
            onChange={e => {
              const val = e.currentTarget.value ?? ''
              setValue(val)
            }}
          />
          {errorValue && <span style={{ color: 'red', fontSize: 12 }}>Value is required</span>}
        </FormControl>)}
        <div style={{ marginBottom: 20 }} />
        <FormControl fullWidth>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
            <Button disabled={isLoading} variant="contained" startIcon={<Icon>search</Icon>} onClick={async () => {
              const isFieldEmpty = field === '-SELECT-'
              setErrorField(isFieldEmpty)
              if (isFieldEmpty) return

              const isValueEmpty = value === '-SELECT-' || value === ''
              setErrorValue(isValueEmpty)
              if (isValueEmpty) return

              const filterObj = {
                name: field,
                operator,
                value: value.trim()
              }

              setFilter(filterObj)
              setSkip(prev => 0)

              await populateUsers(0, takeData, filterObj, sortBy)
            }} color="primary">
              Search
            </Button>
            <div style={{ marginRight: 20 }} />
            <Button disabled={isLoading} variant="contained" startIcon={<Icon>clear</Icon>} onClick={async () => {
              setValue("")
              setField("-SELECT-")
              setFilter(prev => null)
              await populateUsers(skip, takeData, null, sortBy)
            }} color="secondary">
              Clear
            </Button>
          </div>
        </FormControl>
      </form> */}




      <div style={{ marginBottom: 20 }} />
      <Paper className={classes.root}>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column, idx) => (
                  <TableCell
                    key={`column_${idx + 1}`}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {
                    column.label
                    
                    /* {
                    skipSortField.indexOf(column.id) == -1 ? <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : 'asc'}
                      onClick={async (event) => {
                        const isAsc = orderBy === column.id && order === 'asc'
                        setOrder(isAsc ? 'desc' : 'asc')
                        setOrderBy(column.id)
                        const sortByObj = {
                          sortField: column.id,
                          sortDirection: isAsc ? 0 : 1
                        }
                        setSortBy(sortByObj)
                        await populateUsers(skip, takeData, filter, sortByObj)
                      }}
                    >
                      {column.label}
                      {orderBy === column.id ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                      ) : null}
                    </TableSortLabel> : column.label} */}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {users.length > 0 ? users.map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    {columns.map((column, idx) => {
                      const value = column.subId ? row[column.id][column.subId] : row[column.id]
                      return (
                        <TableCell key={`column_${idx + 1}`} align={column.align}>
                          {formatField(column, value, row, index)}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                )
              }) : null}
            </TableBody>
          </Table>
        </TableContainer>
        <div>
          {/* <IconButton disabled={skip == 0 && users.length == 0} onClick={async () => {
            var targetSkip = 0
            if (skip - takeData <= 0) {
              setSkip(prev => 0)
              targetSkip = 0
            } else {
              setSkip(prev => prev - takeData)
              targetSkip = skip - takeData
            }
            await populateUsers(targetSkip, takeData, filter, sortBy)
          }}>
            <ChevronLeftIcon />
          </IconButton>
          <IconButton disabled={users.length == 0} onClick={async () => {
            if (users.length == 0) return
            setSkip(prev => prev + takeData)
            var targetSkip = skip + takeData
            await populateUsers(targetSkip, takeData, filter, sortBy)
          }}>
            <ChevronRightIcon />
          </IconButton> */}
        </div>
      </Paper>
    </>
  )
}

export default Users